(function () {
  if (typeof __webpack_require__ !== 'undefined') {
    var oldGetScript = __webpack_require__.u;
    var oldLoadScript = __webpack_require__.l;
    var oldEnsureScript = __webpack_require__.e;
    var queryMap = {};
    var countMap = {};
    var isTriedFallbackMap = {};
    var getRetryDelay = function () {
      return 250;
    };
    var fallbackPath = '//goalbookapp.com/toolkit/toolkit-spa/';

    __webpack_require__.l = function (url, done, key, chunkId) {
      var retries = countMap.hasOwnProperty(chunkId) ? countMap[chunkId] : 3;
      var finalUrl = url;
      if (retries < 0 && true) {
        finalUrl = url.replace(__webpack_require__.p, fallbackPath);
        isTriedFallbackMap[chunkId] = true;
      }
      var result = oldLoadScript(finalUrl, done, key, chunkId);
      return result;
    };
    __webpack_require__.u = function (chunkId) {
      var result = oldGetScript(chunkId);
      return (
        result +
        (queryMap.hasOwnProperty(chunkId) ? '?' + queryMap[chunkId] : '')
      );
    };
    __webpack_require__.e = function (chunkId) {
      var result = oldEnsureScript(chunkId);
      return result.catch(function (error) {
        var retries = countMap.hasOwnProperty(chunkId) ? countMap[chunkId] : 3;
        if (retries < 1 && true === !!isTriedFallbackMap[chunkId]) {
          var realSrc = oldGetScript(chunkId);
          error.message =
            'Loading chunk ' +
            chunkId +
            ' failed after 3 retries.\n(' +
            realSrc +
            ')';
          error.request = realSrc;

          throw error;
        }
        return new Promise(function (resolve) {
          var retryAttempt = 3 - retries + 1;
          setTimeout(function () {
            var retryAttemptString = '&retry-attempt=' + retryAttempt;
            var cacheBust = 'cache-bust=true' + retryAttemptString;
            queryMap[chunkId] = cacheBust;
            countMap[chunkId] = retries - 1;
            resolve(__webpack_require__.e(chunkId));
          }, getRetryDelay(retryAttempt));
        });
      });
    };
  }
})();
